import { render } from "./Fatturazione.vue?vue&type=template&id=4e038a4a&scoped=true"
import script from "./Fatturazione.vue?vue&type=script&lang=js"
export * from "./Fatturazione.vue?vue&type=script&lang=js"

import "./Fatturazione.vue?vue&type=style&index=0&id=4e038a4a&scoped=true&lang=css"

import exportComponent from "/Users/gigi/Library/ask_admin-deps/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e038a4a"]])

export default __exports__